import React from 'react'

export const NavRight = () => {
    return (
        <>
            <div className="rightbar">
                <div>lokeshkumar991100@gmail.com
                </div>
                <div className="line2"></div>

            </div>
            <script src="lokesh.js"></script>
        </>
    )
}
